import React, {useEffect, useState} from "react";
import enterpriseObjectClassFactory from "../../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../../eoec/eo/EnterpriseObject";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import EventBus from "../../util/EventBus";
import {Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import css_buttons from "../Common/css/CCButton.module.scss";
import {DeleteForever} from "@mui/icons-material";
import CCButton from "../Common/CCButton";


export default function ProjectPlanPhaseDelete(props: any) {
    const [projectPlanPhaseEnterpriseObject] = useState(enterpriseObjectClassFactory("ProjectPlanPhase") as EnterpriseObject);
    const [backgroundOperation, setBackgroundOperation] = useState<boolean>(false);

    function enterpriseComponentDeleteStartedListener(ec: EnterpriseComponent) {
        setBackgroundOperation(true)
    }

    function enterpriseComponentDeleteCompletedListener(ec: EnterpriseComponent) {
        EventBus.components.emit("project-plan-phase-delete-save");
    }

    useEffect(() => {
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!

        projectPlanPhaseEnterpriseComponent.newQuery();
        projectPlanPhaseEnterpriseComponent.setAttributeValue("USID", props.projectPlanPhase.USID);
        projectPlanPhaseEnterpriseComponent.setIDOCRequest("v1.ProjectPlanPhase-001");
        projectPlanPhaseEnterpriseComponent.setIDOCResponse("v1.ProjectPlanPhase-001");
        projectPlanPhaseEnterpriseComponent.executeQuery(1, 5);

        projectPlanPhaseEnterpriseComponent.addDeleteStartedListener(enterpriseComponentDeleteStartedListener);
        projectPlanPhaseEnterpriseComponent.addDeleteCompletedListener(enterpriseComponentDeleteCompletedListener);

        return () => {
            projectPlanPhaseEnterpriseComponent.removeDeleteStartedListener(enterpriseComponentDeleteStartedListener);
            projectPlanPhaseEnterpriseComponent.removeDeleteCompletedListener(enterpriseComponentDeleteCompletedListener);
        }

    }, [projectPlanPhaseEnterpriseObject, props.projectPlanPhase]);

    function onCancelHandler() {
        EventBus.components.emit("project-plan-phase-delete-cancel");
    }

    function deleteHandler() {
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
        projectPlanPhaseEnterpriseComponent.executeDelete();
    }

    function phaseDeleteView() {
        let buttonHandler = null;
        let objectDetailContent = null;

        if (!backgroundOperation) {
            let firstButtonHandlerContent = (
                <CCButton
                    className={css_buttons.redStandardButton}
                    onClick={onCancelHandler}>
                    Cancel
                </CCButton>
            );

            let secondButtonHandlerContent = (
                <CCButton
                    className={css_buttons.blueStandardButton}
                    animate={backgroundOperation}
                    onClick={() => deleteHandler()}>
                    Delete
                </CCButton>
            )

            buttonHandler = (
                <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                    {firstButtonHandlerContent}
                    {secondButtonHandlerContent}
                </DialogActions>
            );
        }

        return (
            <>
                <Dialog open={true} scroll="body">
                    <DialogTitle>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#000000"}}>Delete Phase:&nbsp;&nbsp;</Typography>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#A8A9AF"}}>{props.projectPlanPhase.Name}</Typography>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <div style={{display: "flex", flexDirection: "row", margin: "20px 20px 20px 0"}}>
                                <div>
                                    <DeleteForever sx={{marginTop: "5px", width: "60px", height: "60px", color: "#BD2930"}}/>
                                </div>
                                <div>
                                    <Typography style={{margin: "15px 0 0 6px", fontSize: "16px", fontWeight: 400, color: "#BD2930"}}>Warning! This action will delete this phase, its milestones, and any associated attachments. It cannot be undone!</Typography>
                                </div>

                            </div>
                        </div>
                        {objectDetailContent}
                    </DialogContent>
                    {buttonHandler}
                </Dialog>
            </>
        );
    }

    return (
        <>
            {phaseDeleteView()}
        </>
    )
}
